import React from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import { PhoneInput as KitPhoneInput } from '@beef/ui-kit';
import { selectInputError, selectInputPlaceholder } from "../../../../store/blocks/addressVerification/selectors";
import { selectIsCtnError } from "../../../../store/callbackRequest/selectors";
import { selectIsCheckboxError, showPhoneInputFlag } from "../../../../store/blocks/addressVerification/moduleSelectors";
import { setCtn, setIsCtnError } from "../../../../store/callbackRequest/slice";
import { CheckboxAgreements } from "../../../../components/CheckBoxAgreements";
import { handleViewPhoneInputError } from "../../../../store/blocks/addressVerification/actions/analytics/handleViewPhoneInputError";
import { handleFocusPhoneInput } from "../../../../store/blocks/addressVerification/actions/analytics";
import { Captcha } from "../Captcha";
import { usePhoneInput } from "../../hooks/usePhoneInput";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _PhoneInput = function _PhoneInput(_ref) {
  var placeholder = _ref.placeholder,
    isError = _ref.isError,
    errorText = _ref.errorText,
    handleErrorStatus = _ref.handleErrorStatus,
    onChangePhone = _ref.onChangePhone,
    onFocus = _ref.onFocus,
    isCheckboxError = _ref.isCheckboxError,
    onErrorAnalytics = _ref.onErrorAnalytics;
  var _usePhoneInput = usePhoneInput({
      errorText: errorText,
      handleErrorStatus: handleErrorStatus,
      isError: isError,
      onChangePhone: onChangePhone,
      onFocus: onFocus,
      onErrorAnalytics: onErrorAnalytics
    }),
    handleFocus = _usePhoneInput.handleFocus,
    handleChange = _usePhoneInput.handleChange,
    handlePaste = _usePhoneInput.handlePaste,
    inputRef = _usePhoneInput.inputRef,
    value = _usePhoneInput.value,
    errorMessage = _usePhoneInput.errorMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('container'),
    "data-t-id": "components-PhoneInput"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('input')
  }, /*#__PURE__*/React.createElement(KitPhoneInput, {
    autoComplete: "off",
    errorMessage: errorMessage,
    extraAttributes: {
      onPaste: handlePaste
    },
    inputRef: inputRef,
    maskSettings: {
      mask: '_',
      format: '+7 (###) ###-####'
    },
    name: "phone",
    onChange: handleChange,
    onFocus: handleFocus,
    placeholder: placeholder,
    type: "tel",
    value: value
  })), /*#__PURE__*/React.createElement(CheckboxAgreements, {
    isCheckboxError: isCheckboxError
  }), /*#__PURE__*/React.createElement(Captcha, null));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    placeholder: selectInputPlaceholder(state),
    shouldRender: showPhoneInputFlag(state),
    errorText: selectInputError(state),
    isError: selectIsCtnError(state),
    isCheckboxError: selectIsCheckboxError(state)
  };
};
var mapDispatchToProps = {
  handleErrorStatus: setIsCtnError,
  onChangePhone: setCtn,
  onFocus: handleFocusPhoneInput,
  onErrorAnalytics: handleViewPhoneInputError
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var PhoneInput = compose(connector, withRenderFlag)(_PhoneInput);